// Copyright 2026. WebPros International GmbH. All rights reserved.

import { Dispatch } from 'redux';
import { paginateList } from 'common/actions/actionsWrapper';
import { LOADING_FLAGS } from 'common/modules/app/loadingFlags/constants';
import { IVGpuProfilesListRequest } from 'common/api/resources/Gpu/model';
import {
    gpuProfiles,
    IVGpuProfile,
} from 'common/api/resources/Gpu';
import { createCustomAction } from 'typesafe-actions';
import * as types from 'common/modules/vGpuProfiles/types';
import { IPaginateApiResponse } from 'common/api/resources/Response';

export const getVGpuProfiles = (request?: IVGpuProfilesListRequest) => async (dispatch: Dispatch) => {
    const apiCall = () => gpuProfiles.list(request);

    return await paginateList({
        dispatch,
        loadingFlag: LOADING_FLAGS.V_GPU_PROFILES,
        action: setVGpuProfileList,
        apiCall,
    });
};

export const setVGpuProfileList = createCustomAction(
    types.SET_V_GPU_PROFILES,
    (data: IPaginateApiResponse<IVGpuProfile[]>) => ({ payload: data })
);
